<template>
  <div class="tab-master-ui-custom">
    <el-form
      class="section"
      style="flex-direction: row;line-height: 28px;"
    >
      <el-checkbox v-model="job.insure" :disabled="viewStatus" no="isInsure">{{ $t('SeaExport.InsureInfo') }}</el-checkbox>
      <el-button
        v-if="viewSource === 'AeBooking'"
        v-permission="['button_insurance_toInsure']"
        :disabled="!viewStatus"
        type="primary"
        style="margin-left: 15px;"
        @click="pm.toInsure()"
      >{{ $t('SeaExport.Insure') }}</el-button>
      <div v-if="!!templateName" style="flex-grow: 1;">
        <span class="blue" style="float: right;margin-right: 30px;padding: 0 5px;white-space: nowrap;">{{ $t('CargoMsg.Cargo_SopTemplate') }}: {{ templateName }}</span>
      </div>
    </el-form>
    <el-form ref="basicForm" style="display: flex;" label-position="right" label-width="120px">
      <tab-master-UICustom-layout :element-blocks="elementBlocks" :element-dict="elementDict">
        <el-form-item v-if="elementDict.jobNo && elementDict.jobNo.viewable" slot="jobNo">
          <line-label slot="label" :class="elementDict.jobNo.isRequire ? 'blue' : ''" :label="elementDict.jobNo.label" />
          <el-input v-model="job.jobNo" no="1" :disabled="true" />
        </el-form-item>
        <template v-if="isZY">
          <el-form-item slot="saleProductCode">
            <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.basic_data_AllowSaleProduct"
              filterable
              no="allowSaleProduct"
              clearable
              :data-filter-function="p => {
                if (!p.statusEnabled) {
                  return false
                }
                return isFba ? p.fbaAir : p.airExportEnabled
              }"
              :default-value="job.saleProductCode || ''"
              :disabled="viewStatus"
              @parentCallBack="p => {job.saleProductCode = p.value}"
            />
          </el-form-item>
          <el-form-item slot="fullOrInside">
            <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
            <cargo-advance-select
              :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
              no="fullOrInside"
              clearable
              :default-value="job.fullOrInside || ''"
              :disabled="viewStatus"
              @parentCallBack="p => {job.fullOrInside = p.value}"
            />
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.mbl && elementDict.mbl.viewable" slot="mbl">
          <line-label slot="label" :class="elementDict.mbl.isRequire ? 'blue' : ''" :label="elementDict.mbl.label" />
          <el-checkbox v-model="job.express" :disabled="viewStatus || !elementDict.mbl.writable" style="margin-right: 2px" no="122" @change="expressChangeHandler">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
          <mawb-no-input v-if="!job.express" ref="mawbNoInput" v-model="job.mbl" :editable="viewStatus || isEditablemawbNoInput || !elementDict.mbl.writable" style="width: 100%;margin-bottom: 5px" @change="mblChangeHandler" @changeCallback="mblCheckHandler(true)" />
          <el-input v-if="job.express" v-model="job.mbl" :disabled="viewStatus || !elementDict.mbl.writable" no="21" style="width: 130px;" @change="mblChange" />
          <el-form-item>
            <el-button no="2" type="primary" style="margin-left:1px;padding-left: 10px;padding-right: 10px;" :disabled="!selectBtnEnable" @click="selectMBLNoHandler">{{ selectMawbDialog.btnName }}</el-button>
          </el-form-item>
        </el-form-item>
        <el-form-item v-if="elementDict.dispatchingPlace && elementDict.dispatchingPlace.viewable" slot="dispatchingPlace">
          <line-label slot="label" :class="elementDict.dispatchingPlace.isRequire ? 'blue' : ''" :label="elementDict.dispatchingPlace.label" />
          <el-input
            v-model="job.dispatchingPlace"
            :disabled="viewStatus || !elementDict.dispatchingPlace.writable"
            no="77"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.loadingPortCode && elementDict.loadingPortCode.viewable" slot="loadingPortCode">
          <line-label slot="label" :class="elementDict.loadingPortCode.isRequire ? 'blue' : ''" :label="elementDict.loadingPortCode.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="loading3Code" no="3" style="width: 60px;margin-right: 5px;" :disabled="true" />
            <cargo-advance-select
              no="4"
              filterable
              :select-type="selectTypeNames.basic_data_Airport"
              :default-value="job.loadingPortCode"
              :disabled="viewStatus || !elementDict.loadingPortCode.writable"
              placeholder=" "
              style="flex:1"
              @parentCallBack="p => {pm.loadingPortChangeHandler(p)}"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.destinationPortCode && elementDict.destinationPortCode.viewable" slot="destinationPortCode">
          <line-label slot="label" :class="elementDict.destinationPortCode.isRequire ? 'blue' : ''" :label="elementDict.destinationPortCode.label" />
          <div style="display: flex;justify-content: space-between">
            <el-input v-model="destination3Code" no="5" style="width:60px;margin-right: 5px;" :disabled="true" />
            <cargo-advance-select
              no="6"
              filterable
              :select-type="selectTypeNames.basic_data_Airport"
              :default-value="job.destinationPortCode"
              :disabled="viewStatus || !elementDict.destinationPortCode.writable"
              placeholder=" "
              style="flex:1"
              @parentCallBack="p => {pm.destinationPortCodeChange(p)}"
            />
          </div>
        </el-form-item>
        <template v-if="elementDict.destinationPlace && elementDict.destinationPlace.viewable" slot="destinationPlace">
          <el-form-item>
            <line-label slot="label" :class="elementDict.destinationPlace.isRequire ? 'blue' : ''" :label="elementDict.destinationPlace.label" />
            <el-input v-model="job.destinationPlace" :disabled="viewStatus || !elementDict.destinationPlace.writable" no="7" @input="val => {job.destinationPlace = val ? val.toUpperCase() : ''}" />
          </el-form-item>
          <el-form-item label="">
            <div style="display: flex;justify-content: space-between">
              <el-checkbox v-model="job.transfering" no="8">{{ $t('SeaExport.Transit2') }}</el-checkbox>
              <el-button
                no="9"
                :title="$t('SeaExport.EnterTransitInfo')"
                type="primary"
                :disabled="viewStatus || (!viewStatus && !job.transfering) || !elementDict.destinationPlace.writable"
                style="display: inline-block;width: 100%;overflow: hidden;text-overflow: ellipsis;margin-left: 2px;"
                @click="setTransferingHandler"
              >{{ $t('SeaExport.EnterTransitInfo') }}</el-button>
            </div>
          </el-form-item>
        </template>
        <el-form-item v-if="elementDict.cargoSource && elementDict.cargoSource.viewable" slot="cargoSource">
          <line-label slot="label" :class="elementDict.cargoSource.isRequire ? 'blue' : ''" :label="elementDict.cargoSource.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="10"
              :clearable="false"
              filterable
              :fields="['chineseName']"
              :select-type="selectTypeNames.local_cache_CargoSource"
              callback-method-type="value"
              :default-value="job.cargoSource"
              :callback-params="{key:'cargoSource'}"
              :disabled="viewStatus || !elementDict.cargoSource.writable"
              @parentCallBack="setJobSelectValue"
            />
          </div>
        </el-form-item>
        <!--产品服务-->
        <el-form-item v-if="elementDict.serviceProduct && elementDict.serviceProduct.viewable" slot="serviceProduct">
          <line-label slot="label" :class="elementDict.serviceProduct.isRequire ? 'blue' : ''" :label="elementDict.serviceProduct.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="145"
              :clearable="false"
              filterable
              :select-type="selectTypeNames.basic_data_AirServiceProduct"
              callback-method-type="value"
              :default-value="job.serviceProduct"
              :callback-params="{key:'serviceProduct'}"
              :disabled="viewStatus || !elementDict.serviceProduct.writable"
              @parentCallBack="setJobSelectValue"
            />
          </div>
        </el-form-item>
        <!--航线产品-->
        <el-form-item v-if="elementDict.airlineProductUuid && elementDict.airlineProductUuid.viewable" slot="airlineProductUuid">
          <line-label slot="label" :class="elementDict.airlineProductUuid.isRequire ? 'blue' : ''" :label="elementDict.airlineProductUuid.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-advance-select
              no="airlineProductUuid"
              filterable
              :static-options="airlineProductDownList"
              :method-params="{active:true}"
              tag-value="uuid"
              tag-name="name"
              :filter-tag-names="['name']"
              :static-component="new AutoComplete()"
              callback-method-type="value"
              :default-value="job.airlineProductUuid"
              :callback-params="{key:'airlineProductUuid'}"
              :disabled="viewStatus || !elementDict.airlineProductUuid.writable"
              @parentCallBack="setJobSelectValue"
            />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.customJobType && elementDict.customJobType.viewable" slot="customJobType">
          <line-label slot="label" :class="elementDict.customJobType.isRequire ? 'blue' : ''" :label="elementDict.customJobType.label" />
          <cargo-advance-select
            no="11"
            filterable
            :select-type="selectTypeNames.basic_data_CutomJobType"
            :default-value="job.customJobType"
            :method-params="{type:job.lob}"
            :static-options="customJobTypeList"
            placeholder=" "
            :disabled="viewStatus || !elementDict.customJobType.writable"
            @parentCallBack="p=>{job.customJobType=p.value;oncustomJobTypeChange(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.secondaryCustomJobType && elementDict.secondaryCustomJobType.viewable && job.customJobType && secondaryCustomJobTypeList.length > 0" slot="secondaryCustomJobType">
          <line-label slot="label" :class="elementDict.secondaryCustomJobType.isRequire ? 'blue' : ''" :label="elementDict.secondaryCustomJobType.label" />
          <cargo-advance-select
            ref="secondaryCustomJobType"
            no="secondaryCustomJobType"
            :select-type="selectTypeNames.basic_data_CutomJobType"
            filterable
            :cache="false"
            :default-value="job.secondaryCustomJobType"
            :tag-name="isZh?'name':'englishName'"
            :static-options="secondaryCustomJobTypeList"
            :disabled="viewStatus || !elementDict.secondaryCustomJobType.writable"
            @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.destinationAgent && elementDict.destinationAgent.viewable" slot="destinationAgent">
          <line-label slot="label" :class="elementDict.destinationAgent.isRequire ? 'blue' : ''" :label="elementDict.destinationAgent.label" />
          <cargo-advance-select
            no="12"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{overseaAgent:true, active:true}"
            :default-value="job.destinationAgent||''"
            tag-name="englishName"
            placeholder=" "
            :disabled="viewStatus || !elementDict.destinationAgent.writable"
            @parentCallBack="p=>{pm.destinationAgentChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.designationAgent && elementDict.designationAgent.viewable && job.cargoSource === 'NC'" slot="designationAgent">
          <line-label slot="label" :class="elementDict.designationAgent.isRequire ? 'blue' : ''" :label="elementDict.designationAgent.label" />
          <cargo-advance-select
            no="13"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{designationAgent:true, active:true}"
            callback-method-type="value"
            :default-value="job.designationAgent||''"
            tag-name="englishName"
            :callback-params="{key:'designationAgent'}"
            :disabled="viewStatus || !designationAgentEnabled || !elementDict.designationAgent.writable"
            placeholder=" "
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exChangeAgent && elementDict.exChangeAgent.viewable" slot="exChangeAgent">
          <line-label slot="label" :class="elementDict.exChangeAgent.isRequire ? 'blue' : ''" :label="elementDict.exChangeAgent.label" />
          <cargo-company-select
            no="exChangeAgent"
            :disabled="viewStatus || !job.dischargingPortDoor || !elementDict.exChangeAgent.writable"
            :method-params="{bookingAgent:true,active:true}"
            :default-value="job.exChangeAgent||''"
            @change="onExChangeAgentChange"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingAgent && elementDict.bookingAgent.viewable && bookingAgentVisible" slot="bookingAgent">
          <line-label slot="label" :class="elementDict.bookingAgent.isRequire ? 'blue' : ''" :label="elementDict.bookingAgent.label" />
          <cargo-advance-select
            no="14"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{bookingAgent:true, active: true}"
            callback-method-type="value"
            :default-value="job.bookingAgent||''"
            :callback-params="{key:'bookingAgent'}"
            :disabled="viewStatus || !bookingAgentEnabled || !elementDict.bookingAgent.writable"
            placeholder=" "
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.fileCutoff && elementDict.fileCutoff.viewable" slot="fileCutoff">
          <line-label slot="label" :class="elementDict.fileCutoff.isRequire ? 'blue' : ''" :label="elementDict.fileCutoff.label" />
          <el-date-picker
            ref="fileCutoff"
            v-model="job.fileCutoff"
            no="15"
            type="datetime"
            style="width:100%;"
            clearable
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm"
            :disabled="viewStatus || !elementDict.fileCutoff.writable"
            @blur="()=> { handleBlur('fileCutoff', null, true, false, job) }"
          />
        </el-form-item>
        <!-- 集装器 -->
        <booking-air-uld-data-grid
          v-if="elementDict.airUlds && elementDict.airUlds.viewable"
          slot="airUlds"
          :value="airUlds"
          :is-edit="!viewStatus && elementDict.airUlds.writable"
          :job="job"
          style="width: 100%"
        />
        <el-form-item v-if="elementDict.carrierId && elementDict.carrierId.viewable" slot="carrierId" label-width="120px">
          <line-label slot="label" :class="elementDict.carrierId.isRequire ? 'blue' : ''" :label="elementDict.carrierId.label" />
          <cargo-advance-select
            no="34"
            filterable
            :select-type="selectTypeNames.basic_data_Company"
            :method-params="{airCmp:true, active:true}"
            :default-value="job.carrierId || ''"
            :disabled="viewStatus || !carrierIdEnabled || !elementDict.carrierId.writable"
            :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
            :fields="['shortName', 'chineseName']"
            placeholder=" "
            @parentCallBack="p => {pm.carrierChangeHandler(p.value||0);pm.airlineCompanyChange(p.value||0);airlineCompanyCheckHandler(p.value||0)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.carrierWebsite && elementDict.carrierWebsite.viewable" slot="carrierWebsite">
          <line-label slot="label" :class="elementDict.carrierWebsite.isRequire ? 'blue' : ''" :label="elementDict.carrierWebsite.label" />
          <cargo-textarea v-model="job.carrierWebsite" no="carrierWebsite" type="textarea" :row="3" :disabled="!elementDict.carrierWebsite.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.voyageFlight && elementDict.voyageFlight.viewable" slot="voyageFlight" label-width="120px">
          <line-label slot="label" :class="elementDict.voyageFlight.isRequire ? 'blue' : ''" :label="elementDict.voyageFlight.label" />
          <el-input v-model="job.voyageFlight" :disabled="viewStatus || !elementDict.voyageFlight.writable" no="35" @change="voyageFlightCheckHandler" />
        </el-form-item>
        <el-form-item v-if="elementDict.customsDate && elementDict.customsDate.viewable" slot="customsDate" label-width="120px">
          <line-label slot="label" :class="elementDict.customsDate.isRequire ? 'blue' : ''" :label="elementDict.customsDate.label" />
          <el-date-picker
            v-model="job.customsDate"
            :disabled="viewStatus || !elementDict.customsDate.writable"
            no="36"
            value-format="yyyy-MM-dd"
            type="date"
            clearable
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.etd && elementDict.etd.viewable" slot="etd" label-width="120px">
          <line-label slot="label" :class="elementDict.etd.isRequire ? 'blue' : ''" :label="elementDict.etd.label" />
          <div style="display: flex">
            <el-date-picker
              ref="etd"
              :value="job.etd"
              :disabled="viewStatus || !elementDict.etd.writable || provisionEtdLocked"
              no="37"
              clearable
              type="datetime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              style="flex: 1; width:140px; margin-right: 5px"
              @input="etdChange"
              @blur="()=> { handleBlur('etd', etdChange, false, false, job) }"
            />
            <span>{{ job.sailingDay|filterWeek }}</span>
          </div>
          <span v-if="provisionEtdLocked" style="color: red; font-size: 12px;">(已计提校准不可修改)</span>
        </el-form-item>
        <el-form-item v-if="elementDict.eta && elementDict.eta.viewable" slot="eta" label-width="120px">
          <line-label slot="label" :class="elementDict.eta.isRequire ? 'blue' : ''" :label="elementDict.eta.label" />
          <div style="display: flex">
            <el-date-picker
              ref="eta"
              v-model="job.eta"
              :disabled="viewStatus || !elementDict.eta.writable"
              no="38"
              style="flex: 1; width:140px; margin-right: 5px"
              type="datetime"
              clearable
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              @input="etaChange"
              @blur="()=> { handleBlur('eta', etaChange, false, false, job) }"
            />
            <span>{{ job.etaSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.atd && elementDict.atd.viewable" slot="atd" label-width="120px">
          <line-label slot="label" :class="elementDict.atd.isRequire ? 'blue' : ''" :label="elementDict.atd.label" />
          <div style="display: flex">
            <el-date-picker
              ref="atd"
              :value="job.atd"
              no="39"
              :disabled="viewStatus || !elementDict.atd.writable"
              style="flex: 1; width:140px; margin-right: 5px"
              type="datetime"
              clearable
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              @input="atdChange"
              @blur="()=> { handleBlur('atd', atdChange, false, false, job) }"
            />
            <span>{{ job.atdSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.ata && elementDict.ata.viewable" slot="ata" label-width="120px">
          <line-label slot="label" :class="elementDict.ata.isRequire ? 'blue' : ''" :label="elementDict.ata.label" />
          <div style="display: flex">
            <el-date-picker
              ref="ata"
              v-model="job.ata"
              no="40"
              :disabled="viewStatus || !elementDict.ata.writable"
              style="flex: 1; width:140px; margin-right: 5px"
              type="datetime"
              clearable
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              @input="ataChange"
              @blur="()=> { handleBlur('ata', ataChange, false, false, job) }"
            />
            <span>{{ job.ataSailingDay|filterWeek }}</span>
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoCode && elementDict.cargoCode.viewable" slot="cargoCode" label-width="120px">
          <line-label slot="label" :class="elementDict.cargoCode.isRequire ? 'blue' : ''" :label="elementDict.cargoCode.label" />
          <cargo-advance-select
            no="42"
            :select-type="selectTypeNames.basic_data_CargoInformation"
            filterable
            :callback-params="{key:'cargoCode'}"
            :default-value="job.cargoCode"
            :disabled="viewStatus || !elementDict.cargoCode.writable"
            placeholder=" "
            @parentCallBack="txtCargoInformationChangeHandler"
          />
          <el-input v-model="job.cargoName" :disabled="!job.cargoCode" />
        </el-form-item>
        <el-form-item v-if="elementDict.transportSource && elementDict.transportSource.viewable" slot="transportSource" label-width="120px">
          <line-label slot="label" :class="elementDict.transportSource.isRequire ? 'blue' : ''" :label="elementDict.transportSource.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_TransportSource"
            no="transportSource"
            :default-value="job.transportSource"
            :cache="false"
            tag-value="code"
            placeholder=" "
            :disabled="viewStatus || !elementDict.transportSource.writable"
            @parentCallBack="item=>job.transportSource=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.statisticArea && elementDict.statisticArea.viewable" slot="statisticArea" label-width="120px">
          <line-label slot="label" :class="elementDict.statisticArea.isRequire ? 'blue' : ''" :label="elementDict.statisticArea.label" />
          <cargo-advance-select
            filterable
            :select-type="selectTypeNames.basic_data_StatisticArea"
            no="statisticArea"
            :default-value="job.statisticArea"
            :cache="false"
            tag-value="code"
            placeholder=" "
            :disabled="viewStatus || !elementDict.statisticArea.writable"
            @parentCallBack="item=>job.statisticArea=item.value"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.paymentTermMBL && elementDict.paymentTermMBL.viewable" slot="paymentTermMBL">
          <line-label slot="label" :class="elementDict.paymentTermMBL.isRequire ? 'blue' : ''" :label="elementDict.paymentTermMBL.label" />
          <cargo-advance-select
            no="43"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.basic_data_PaymentTerm"
            :default-value="job.paymentTermMBL || ''"
            :disabled="viewStatus || !elementDict.paymentTermMBL.writable"
            @parentCallBack="p => pm.paymentTermMBLChangeHandler(p)"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.bookingTerm && elementDict.bookingTerm.viewable" slot="bookingTerm">
          <line-label slot="label" :class="elementDict.bookingTerm.isRequire ? 'blue' : ''" :label="elementDict.bookingTerm.label" />
          <cargo-advance-select
            no="44"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.local_cache_BookingTerm"
            :default-value="job.bookingTerm"
            :fields="['chineseName']"
            :disabled="viewStatus || !elementDict.bookingTerm.writable"
            @parentCallBack="p => {pm.bookingTermChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.portOfDestinationServices && elementDict.portOfDestinationServices.viewable && isAeBooking" slot="portOfDestinationServices">
          <line-label slot="label" :class="elementDict.portOfDestinationServices.isRequire ? 'blue' : ''" :label="elementDict.portOfDestinationServices.label" />
          <el-checkbox
            v-model="job.dischargingPortDoor"
            :disabled="viewStatus || !elementDict.portOfDestinationServices.writable"
            no="dischargingPortDoor"
            class="checkbox-content"
            :title="$t('SeaExport.DispatchVehiclesAtDestination')"
            @change="syncSlaves('dischargingPortDoor')"
          >{{ $t('SeaExport.DispatchVehiclesAtDestination') }}
          </el-checkbox>
          <el-checkbox
            v-model="job.usCustomsClearance"
            :disabled="viewStatus || !elementDict.portOfDestinationServices.writable"
            no="usCustomsClearance"
            class="checkbox-content"
            :title="$t('queryJob.UsCustomsClearance')"
            @change="syncSlaves('usCustomsClearance')"
          >{{ $t('queryJob.UsCustomsClearance') }}
          </el-checkbox>
          <el-checkbox
            v-model="job.destPortCustomsClearance"
            :disabled="viewStatus || !elementDict.portOfDestinationServices.writable"
            no="destPortCustomsClearance"
            class="checkbox-content"
            :title="$t('SeaExport.PortOfDestinationCustomsClearance')"
          >{{ $t('SeaExport.PortOfDestinationCustomsClearance') }}
          </el-checkbox>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoType && elementDict.cargoType.viewable" slot="cargoType">
          <line-label slot="label" :class="elementDict.cargoType.isRequire ? 'blue' : ''" :label="elementDict.cargoType.label" />
          <cargo-advance-select
            no="45"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.basic_data_CargoType"
            callback-method-type="value"
            :default-value="job.cargoType"
            :callback-params="{key:'cargoType'}"
            :disabled="viewStatus || !elementDict.cargoType.writable"
            @parentCallBack="onCargoTypeChagne"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.salesChannel && elementDict.salesChannel.viewable" slot="salesChannel">
          <line-label slot="label" :class="elementDict.salesChannel.isRequire ? 'blue' : ''" :label="elementDict.salesChannel.label" />
          <el-input
            v-model="job.salesChannel"
            :disabled="true"
            no="82"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.trustFromJob && elementDict.trustFromJob.viewable" slot="trustFromJob">
          <line-label slot="label" :class="elementDict.trustFromJob.isRequire ? 'blue' : ''" :label="elementDict.trustFromJob.label" />
          <el-input
            v-model="job.trustFromJob"
            :disabled="true"
            no="trustFromJob"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.relatedJob && elementDict.relatedJob.viewable" slot="relatedJob">
          <line-label slot="label" :class="elementDict.relatedJob.isRequire ? 'blue' : ''" :label="elementDict.relatedJob.label" />
          <el-input
            v-model="job.relatedJob"
            :disabled="true"
            no="relatedJob"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.channelNo && elementDict.channelNo.viewable && showChannelNo" slot="channelNo">
          <line-label slot="label" :class="elementDict.channelNo.isRequire ? 'blue' : ''" :label="elementDict.channelNo.label" />
          <el-input v-model="job.channelNo" :disabled="true" no="83" />
        </el-form-item>
        <el-form-item v-if="elementDict.measurements && elementDict.measurements.viewable" slot="measurements">
          <line-label slot="label" :class="elementDict.measurements.isRequire ? 'blue' : ''" :label="elementDict.measurements.label" />
          <el-input v-model="measurements" no="47" type="textarea" :rows="5" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.remarks && elementDict.remarks.viewable" slot="remarks">
          <line-label slot="label" :class="elementDict.remarks.isRequire ? 'blue' : ''" :label="elementDict.remarks.label" />
          <el-input
            v-model="job.remarks"
            :disabled="viewStatus || !elementDict.remarks.writable"
            no="48"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.remarks.label,job.remarks,val=>{job.remarks=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.frontEndWarehouseOperation && elementDict.frontEndWarehouseOperation.viewable" slot="frontEndWarehouseOperation">
          <line-label slot="label" :class="elementDict.frontEndWarehouseOperation.isRequire ? 'blue' : ''" :label="elementDict.frontEndWarehouseOperation && elementDict.frontEndWarehouseOperation.label" />
          <cargo-advance-select
            no="frontEndWarehouseOperation"
            :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
            :method-params="{dataType:1, deletionFlag: false}"
            filterable
            :clearable="true"
            :default-value="job.frontEndWarehouseOperation"
            :disabled="viewStatus || !elementDict.frontEndWarehouseOperation.writable"
            @parentCallBack="p=>{job.frontEndWarehouseOperation=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.agentInformation && elementDict.agentInformation.viewable" slot="agentInformation">
          <line-label slot="label" :class="elementDict.agentInformation.isRequire ? 'blue' : ''" :label="elementDict.agentInformation.label" />
          <cargo-textarea v-model="job.agentInformation" no="agentInformation" type="textarea" :row="3" :disabled="!elementDict.agentInformation.writable" />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.viewable" slot="cargoTerminalOperation">
          <line-label slot="label" :class="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.isRequire ? 'blue' : ''" :label="elementDict.cargoTerminalOperation && elementDict.cargoTerminalOperation.label" />
          <cargo-advance-select
            no="cargoTerminalOperation"
            :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
            :method-params="{dataType:0, deletionFlag: false}"
            filterable
            :clearable="true"
            :default-value="job.cargoTerminalOperation"
            :disabled="viewStatus || !elementDict.cargoTerminalOperation.writable"
            @parentCallBack="p=>{job.cargoTerminalOperation=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.viewable" slot="estimatedDeliveryDate">
          <line-label slot="label" :class="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.isRequire ? 'blue' : ''" :label="elementDict.estimatedDeliveryDate && elementDict.estimatedDeliveryDate.label" />
          <el-date-picker v-model="job.estimatedDeliveryDate" :disabled="!isEdit || !job.cargoTerminalOperation || !elementDict.estimatedDeliveryDate.writable" no="estimatedDeliveryDate" style="flex: 1; width:200px; margin-right: 5px" type="date" value-format="yyyy-MM-dd" clearable />
        </el-form-item>
        <el-form-item v-if="elementDict.customerRefNo && elementDict.customerRefNo.viewable" slot="customerRefNo">
          <line-label slot="label" :class="elementDict.customerRefNo.isRequire ? 'blue' : ''" :label="elementDict.customerRefNo.label" />
          <cargo-input v-model="job.customerRefNo" :disabled="viewStatus || !elementDict.customerRefNo.writable" no="76" :trim="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.tradeTerm && elementDict.tradeTerm.viewable" slot="tradeTerm">
          <line-label slot="label" :class="elementDict.tradeTerm.isRequire ? 'blue' : ''" :label="elementDict.tradeTerm.label" />
          <cargo-advance-select
            no="50"
            filterable
            :clearable="false"
            :select-type="selectTypeNames.basic_data_TradeTerm"
            callback-method-type="value"
            :default-value="job.tradeTerm"
            :callback-params="{key:'tradeTerm'}"
            :disabled="viewStatus || !elementDict.tradeTerm.writable"
            @parentCallBack="setJobSelectValue"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcOffice && elementDict.dcOffice.viewable" slot="dcOffice">
          <line-label slot="label" :class="elementDict.dcOffice.isRequire ? 'blue' : ''" :label="elementDict.dcOffice.label" />
          <cargo-office-select
            no="dcOffice"
            :disabled="true"
            :office-id="Number(job.dcOffice)"
            @change="p=>{job.dcOffice=p.value;job.dcDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.dcDepartment && elementDict.dcDepartment.viewable" slot="dcDepartment">
          <line-label slot="label" :class="elementDict.dcDepartment.isRequire ? 'blue' : ''" :label="elementDict.dcDepartment.label" />
          <cargo-department-select
            no="dcDepartment"
            :office-id="Number(job.dcOffice)"
            :enables="true"
            :department-id="Number(job.dcDepartment)"
            :disabled="viewStatus || !elementDict.dcDepartment.writable"
            @change="p=>{job.dcDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.dc && elementDict.dc.viewable" slot="dc">
          <line-label slot="label" :class="elementDict.dc.isRequire ? 'blue' : ''" :label="elementDict.dc.label" />
          <cargo-user-select
            ref="dc"
            no="51"
            :method-params="{category:'role',shape:'doc'}"
            :default-value="job.dc||''"
            placeholder=" "
            :static-options="userPortRoleData.doc"
            :disabled="viewStatus || !elementDict.dc.writable"
            @change="p=>{pm.dcChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerOffice && elementDict.plannerOffice.viewable" slot="plannerOffice">
          <line-label slot="label" :class="elementDict.plannerOffice.isRequire ? 'blue' : ''" :label="elementDict.plannerOffice.label" />
          <cargo-office-select
            no="plannerOffice"
            :disabled="true"
            :office-id="Number(job.plannerOffice)"
            @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.plannerDepartment && elementDict.plannerDepartment.viewable" slot="plannerDepartment">
          <line-label slot="label" :class="elementDict.plannerDepartment.isRequire ? 'blue' : ''" :label="elementDict.plannerDepartment.label" />
          <cargo-department-select
            no="plannerDepartment"
            :office-id="Number(job.plannerOffice)"
            :enables="true"
            :department-id="Number(job.plannerDepartment)"
            :disabled="viewStatus || !elementDict.plannerDepartment.writable"
            @change="p=>{job.plannerDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.planner && elementDict.planner.viewable" slot="planner">
          <line-label slot="label" :class="elementDict.planner.isRequire ? 'blue' : ''" :label="elementDict.planner.label" />
          <cargo-user-select
            no="52"
            :method-params="{officeId:job.opOffice,category:'role',shape:'airline'}"
            :default-value="job.planner||''"
            placeholder=" "
            :static-options="userPortRoleData.airline"
            :disabled="viewStatus || !elementDict.planner.writable"
            @change="p=>{pm.plannerChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.siteOP && elementDict.siteOP.viewable" slot="siteOP">
          <line-label slot="label" :class="elementDict.siteOP.isRequire ? 'blue' : ''" :label="elementDict.siteOP.label" />
          <cargo-user-select
            no="53"
            :method-params="{officeId:job.opOffice,category:'role',shape:'siteOp'}"
            :default-value="job.siteOP||''"
            placeholder=" "
            :static-options="userPortRoleData.siteOp"
            :disabled="viewStatus || !elementDict.siteOP.writable"
            @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoSalesId && elementDict.cargoSalesId.viewable" slot="cargoSalesId">
          <line-label slot="label" :class="elementDict.cargoSalesId.isRequire ? 'blue' : ''" :label="elementDict.cargoSalesId.label" />
          <cargo-user-select
            no="54"
            :method-params="{category:'role',shape:'salesOfGoods'}"
            :default-value="job.cargoSalesId||''"
            placeholder=" "
            :disabled="viewStatus || !elementDict.cargoSalesId.writable"
            @change="p=>{job.cargoSalesId = p.value;pm.cargoSalesChargeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.txtSalesOffice && elementDict.txtSalesOffice.viewable" slot="txtSalesOffice">
          <line-label slot="label" :class="elementDict.txtSalesOffice.isRequire ? 'blue' : ''" :label="elementDict.txtSalesOffice.label" />
          <el-input v-model="txtSalesOffice" no="55" :disabled="true" />
        </el-form-item>
        <el-form-item v-if="elementDict.salesDepartment && elementDict.salesDepartment.viewable" slot="salesDepartment">
          <line-label slot="label" :class="elementDict.salesDepartment.isRequire ? 'blue' : ''" :label="elementDict.salesDepartment.label" />
          <cargo-department-new-select
            no="56"
            :disabled="viewStatus || !job.sales || !elementDict.salesDepartment.writable"
            :enables="true"
            :sales-id="Number(job.sales)"
            :office-id="job.salesOffice"
            :department-id="Number(job.salesDepartment)"
            @change="p=>{pm.salesDepartmentChargeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.sales && elementDict.sales.viewable" slot="sales">
          <line-label slot="label" :class="elementDict.sales.isRequire ? 'blue' : ''" :label="elementDict.sales.label" />
          <div style="display: flex;justify-content: space-between">
            <cargo-user-select
              ref="sales"
              no="57"
              :disabled="viewStatus || !saleEnabled || !elementDict.sales.writable"
              :method-params="{officeId:pm.salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales',active:true}"
              :default-value="job.sales||''"
              :static-options="salesList"
              :placeholder="salesPrompt||' '"
              style="width: 130px;flex: 1"
              @change="p=>{pm.salesChangeHandler(p);}"
            />&nbsp;
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.opOffice && elementDict.opOffice.viewable" slot="opOffice">
          <line-label slot="label" :class="elementDict.opOffice.isRequire ? 'blue' : ''" :label="elementDict.opOffice.label" />
          <cargo-office-select
            no="58"
            :disabled="viewStatus || opOfficeDisabled || !elementDict.opOffice.writable"
            :office-id="Number(job.opOffice)"
            placeholder=" "
            :is-regional-commission="isRegionalCommission"
            @change="p=>{pm.opOfficeChargeHandler(p);}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.opDepartment && elementDict.opDepartment.viewable" slot="opDepartment">
          <line-label slot="label" :class="elementDict.opDepartment.isRequire ? 'blue' : ''" :label="elementDict.opDepartment.label" />
          <cargo-department-select
            no="59"
            :office-id="Number(job.opOffice)"
            :enables="true"
            :department-id="Number(job.opDepartment)"
            placeholder=" "
            :disabled="viewStatus || !elementDict.opDepartment.writable"
            @change="p=>{job.opDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.op && elementDict.op.viewable" slot="op">
          <line-label slot="label" :class="elementDict.op.isRequire ? 'blue' : ''" :label="elementDict.op.label" />
          <cargo-user-select
            no="60"
            :method-params="{officeId:job.opOffice,category:'role',shape:'op'}"
            :default-value="job.op||''"
            placeholder=" "
            :static-options="userPortRoleData.op"
            :disabled="viewStatus || !elementDict.op.writable"
            @change="p=>{pm.opChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrOffice && elementDict.csrOffice.viewable" slot="csrOffice">
          <line-label slot="label" :class="elementDict.csrOffice.isRequire ? 'blue' : ''" :label="elementDict.csrOffice.label" />
          <cargo-office-select
            no="csrOffice"
            :disabled="true"
            :office-id="Number(job.csrOffice)"
            @change="p=>{job.csrOffice=p.value;job.csrDepartment=0}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csrDepartment && elementDict.csrDepartment.viewable" slot="csrDepartment">
          <line-label slot="label" :class="elementDict.csrDepartment.isRequire ? 'blue' : ''" :label="elementDict.csrDepartment.label" />
          <cargo-department-select
            no="csrDepartment"
            :office-id="Number(job.csrOffice)"
            :enables="true"
            :department-id="Number(job.csrDepartment)"
            :disabled="viewStatus || !elementDict.csrDepartment.writable"
            @change="p=>{job.csrDepartment=p.value}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.csr && elementDict.csr.viewable" slot="csr">
          <line-label slot="label" :class="elementDict.csr.isRequire ? 'blue' : ''" :label="elementDict.csr.label" />
          <cargo-user-select
            no="61"
            :method-params="{category:'role',shape:'csr'}"
            :default-value="job.csr||''"
            placeholder=" "
            :static-options="userPortRoleData.csr"
            :disabled="viewStatus || !elementDict.csr.writable"
            @change="p=>{pm.csrChangeHandler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId1 && elementDict.userDefinedRoleId1.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId1">
          <line-label slot="label" :class="elementDict.userDefinedRoleId1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId1.label" />
          <cargo-user-select
            ref="userDefinedRoleId1"
            no="userDefinedRoleId1"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
            :default-value="job.userDefinedRoleId1||''"
            :merge-load="true"
            placeholder=" "
            :static-options="userPortRoleData.userDefinedRole1"
            :disabled="viewStatus || !elementDict.userDefinedRoleId1.writable"
            @change="p=>{pm.userDefinedRoleId1Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-show="elementDict.userDefinedRoleId2 && elementDict.userDefinedRoleId2.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId2">
          <line-label slot="label" :class="elementDict.userDefinedRoleId2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId2.label" />
          <cargo-user-select
            ref="userDefinedRoleId2"
            no="userDefinedRoleId2"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
            :default-value="job.userDefinedRoleId2||''"
            :merge-load="true"
            placeholder=" "
            :static-options="userPortRoleData.userDefinedRole2"
            :disabled="viewStatus || !elementDict.userDefinedRoleId2.writable"
            @change="p=>{pm.userDefinedRoleId2Handler(p)}"
          />
        </el-form-item>
        <!-- <div v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId3">
          <micro-app
            name="child-user-defined-role-ae-master-userDefinedRoleId3"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div>
        <div v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && $store.getters.enableFrontEndPlugin" slot="userDefinedRoleId4">
          <micro-app
            name="child-user-defined-role-ae-master-userDefinedRoleId4"
            :url="$store.getters.frontEndPluginUrl+'/userDefinedRoleItem'"
            router-mode="pure"
            destroy
            @datachange="userDefinedRoleDataChangeUI"
          />
        </div> -->
        <el-form-item v-if="elementDict.userDefinedRoleId3 && elementDict.userDefinedRoleId3.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId3">
          <line-label slot="label" :class="elementDict.userDefinedRoleId3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId3.label" />
          <cargo-user-select
            ref="userDefinedRoleId3"
            no="userDefinedRoleId3"
            :disabled="viewStatus || !elementDict.userDefinedRoleId3.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole3'}"
            :default-value="job.userDefinedRoleId3||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole3"
            @change="p=>{pm.userDefinedRoleId3Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId4 && elementDict.userDefinedRoleId4.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId4">
          <line-label slot="label" :class="elementDict.userDefinedRoleId4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId4.label" />
          <cargo-user-select
            ref="userDefinedRoleId4"
            no="userDefinedRoleId4"
            :disabled="viewStatus || !elementDict.userDefinedRoleId4.writable"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole4'}"
            :default-value="job.userDefinedRoleId4||''"
            :merge-load="true"
            :static-options="userPortRoleData.userDefinedRole4"
            @change="p=>{pm.userDefinedRoleId4Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId5 && elementDict.userDefinedRoleId5.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId5">
          <line-label slot="label" :class="elementDict.userDefinedRoleId5.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId5.label" />
          <cargo-user-select
            ref="userDefinedRoleId5"
            no="userDefinedRoleId5"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole5'}"
            :default-value="job.userDefinedRoleId5||''"
            :merge-load="true"
            :disabled="viewStatus || !elementDict.userDefinedRoleId5.writable"
            @change="p=>{pm.userDefinedRoleId5Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId6 && elementDict.userDefinedRoleId6.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId6">
          <line-label slot="label" :class="elementDict.userDefinedRoleId6.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId6.label" />
          <cargo-user-select
            ref="userDefinedRoleId6"
            no="userDefinedRoleId6"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole6'}"
            :default-value="job.userDefinedRoleId6||''"
            :merge-load="true"
            :disabled="viewStatus || !elementDict.userDefinedRoleId6.writable"
            @change="p=>{pm.userDefinedRoleId6Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId7 && elementDict.userDefinedRoleId7.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId7">
          <line-label slot="label" :class="elementDict.userDefinedRoleId7.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId7.label" />
          <cargo-user-select
            ref="userDefinedRoleId7"
            no="userDefinedRoleId7"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole7'}"
            :default-value="job.userDefinedRoleId7||''"
            :merge-load="true"
            :disabled="viewStatus || !elementDict.userDefinedRoleId7.writable"
            @change="p=>{pm.userDefinedRoleId7Handler(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedRoleId8 && elementDict.userDefinedRoleId8.viewable && isAddUserDefinedRoles" slot="userDefinedRoleId8">
          <line-label slot="label" :class="elementDict.userDefinedRoleId8.isRequire ? 'blue' : ''" :label="elementDict.userDefinedRoleId8.label" />
          <cargo-user-select
            ref="userDefinedRoleId8"
            no="userDefinedRoleId8"
            :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole8'}"
            :default-multiple-value="toNumArray(job.userDefinedRoleId8)"
            :multiple="true"
            :merge-load="true"
            :placeholder="viewStatus ? ' ' : ''"
            :disabled="viewStatus || !elementDict.userDefinedRoleId8.writable"
            @change="p=>{job.userDefinedRoleId8=toTxt(p.value)}"
          />
        </el-form-item>
        <!-- FBA相关信息-->
        <div v-if="isFba" class="section form-column">
          <el-form :disabled="viewStatus" label-width="120px" label-position="right">
            <el-form-item :label="$t('AirExport.ServiceChannel')">
              <el-input v-model="fbaJob.serviceChannel" no="serviceChannel" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('AirExport.EstimatedStorageGoodArrivalTime') }}</span>
              <el-date-picker
                v-model="fbaJob.preWarehousingTime"
                no="preWarehousingTime"
                type="datetime"
                style="width:100%;"
                clearable
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_Destination') }}</span>
              <div style="display: flex; flex: 1;">
                <el-tooltip :content="fbaJob.warehouseCode" placement="bottom-end">
                  <el-cascader
                    v-model="fbaJob.warehouseCode"
                    style="padding-right: 2px;"
                    :options="destinations"
                    filterable
                    :clearable="true"
                    no="84"
                    @focus="JobUtils.focusWarehouseCode(fbaJob)"
                    @blur="JobUtils.blurWarehouseCode(fbaJob)"
                    @change="p=>{JobUtils.warehouseCodeHandler(fbaJob, p);}"
                  />
                </el-tooltip>
                <el-checkbox v-model="fbaJob.remoteWarehouse" no="remoteWarehouse">{{ $t('AirExport.RemoteWarehouse') }}</el-checkbox>
              </div>
            </el-form-item>
            <el-form-item :label="$t('Warehouse.DestinationCountry')">
              <el-input v-model="fbaJob.country" :disabled="true" no="country" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.ZipCode')">
              <el-input v-model="fbaJob.zipCode" :disabled="true" no="zipCode" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.DestinationDeliveryMethod')">
              <cargo-advance-select
                no="destinationDistribution"
                :select-type="selectTypeNames.local_cache_FbaJobConstants$ORDER_DESTINATION_DISTRIBUTION_TYPES"
                filterable
                :clearable="false"
                :default-value="fbaJob.destinationDistribution"
                @parentCallBack="p=>{fbaJob.destinationDistribution=p.value}"
              />
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierCompany')">
              <el-select v-model="fbaJob.expressCompany" no="expressCompany" placeholder="" clearable>
                <el-option
                  v-for="item in FbaJobConstants.EXPRESS_COMPANYS"
                  :key="item.code"
                  :label="item.chineseName"
                  :value="item.code"
                />
              </el-select>
            </el-form-item>
            <el-form-item v-if="fbaJob.destinationDistribution && Number(fbaJob.destinationDistribution) === 1" :label="$t('AirExport.CourierNumber')">
              <el-input v-model="fbaJob.expressNo" no="expressNo" />
            </el-form-item>
            <el-form-item :label="$t('AirExport.DomesticWarehouse')">
              <cargo-company-select
                no="warehouseCmp"
                :method-params="{warehouse:true,active:true}"
                :default-value="Number(fbaJob.domesticWarehouse)||''"
                :placeholder="$t('SeaExport.PleaseSelectWarehouse')"
                @change="p=>{fbaJob.domesticWarehouse=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.ForeignWarehouse')">
              <cargo-advance-select
                no="overseaWarehouseCode"
                :select-type="selectTypeNames.basic_data_OverseaWarehouse"
                filterable
                :method-params="{ifFba:false}"
                :clearable="false"
                tag-name="countryChineseName"
                tag-value="warehouseCode"
                :default-value="job.overseaWarehouseCode"
                style="width:100%;"
                @parentCallBack="p=>{job.overseaWarehouseCode=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.CustomsDeclarationMethod')">
              <cargo-advance-select
                no="customsMethodPol"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:0}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPol"
                @parentCallBack="p=>{fbaJob.customsMethodPol=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomsDeclarationType')">
              <cargo-advance-select
                no="customsDeclarationType"
                :select-type="selectTypeNames.basic_data_CustomsDeclarationType"
                filterable
                :default-value="job.customsDeclarationType||''"
                :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
                @parentCallBack="p=>{job.customsDeclarationType=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.CustomsClearanceMethod')">
              <cargo-advance-select
                no="customsMethodPod"
                :select-type="selectTypeNames.basic_data_CustomsMode"
                :method-params="{serviceType:1}"
                filterable
                :clearable="false"
                :default-value="fbaJob.customsMethodPod"
                @parentCallBack="p=>{fbaJob.customsMethodPod=p.value}"
              />
            </el-form-item>

            <hr style="margin-top: 20px;margin-bottom: 20px;">
            <span class="title">{{ $t('SeaExport.PODDeliveryInformation') }}</span>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="job.estWarehouseDeliveryTime"
                no="estWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.DeliveryToWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToWarehouseTime')">
              <el-date-picker
                v-model="job.actWarehouseDeliveryTime"
                no="actWarehouseDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.EstimatedDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="job.estGoodsDeliveryTime"
                no="estGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :title="$t('SeaExport.ActualDeliveryToCustomersWarehouseMessage')" :label="$t('SeaExport.ActualDeliveryToCustomersWarehouseTime')">
              <el-date-picker
                v-model="job.actGoodsDeliveryTime"
                no="actGoodsDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.EstimatedDeliveryTime')">
              <el-date-picker
                v-model="job.estDeliveryTime"
                no="estDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
            <el-form-item :label="$t('AirExport.ActualDeliveryTime')">
              <el-date-picker
                v-model="job.actDeliveryTime"
                no="actDeliveryTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm"
                style="width: 100%"
              />
            </el-form-item>
          </el-form>
        </div>
        <el-form-item v-if="elementDict.userDefinedField1 && elementDict.userDefinedField1.viewable" slot="userDefinedField1">
          <line-label slot="label" :class="elementDict.userDefinedField1.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField1.label" />
          <el-input
            v-model="job.userDefinedField1"
            :disabled="viewStatus || !elementDict.userDefinedField1.writable"
            no="62"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField1.label,job.userDefinedField1,val=>{job.userDefinedField1=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField2 && elementDict.userDefinedField2.viewable" slot="userDefinedField2">
          <line-label slot="label" :class="elementDict.userDefinedField2.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField2.label" />
          <el-input
            v-model="job.userDefinedField2"
            :disabled="viewStatus || !elementDict.userDefinedField2.writable"
            no="63"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField2.label,job.userDefinedField2,val=>{job.userDefinedField2=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField3 && elementDict.userDefinedField3.viewable" slot="userDefinedField3">
          <line-label slot="label" :class="elementDict.userDefinedField3.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField3.label" />
          <el-input
            v-model="job.userDefinedField3"
            :disabled="viewStatus || !elementDict.userDefinedField3.writable"
            no="64"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField3.label,job.userDefinedField3,val=>{job.userDefinedField3=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.userDefinedField4 && elementDict.userDefinedField4.viewable" slot="userDefinedField4">
          <line-label slot="label" :class="elementDict.userDefinedField4.isRequire ? 'blue' : ''" :label="elementDict.userDefinedField4.label" />
          <el-input
            v-model="job.userDefinedField4"
            :disabled="viewStatus || !elementDict.userDefinedField4.writable"
            no="65"
            type="textarea"
            :rows="5"
            @dblclick.native="showAdvanceTextDialog(elementDict.userDefinedField4.label,job.userDefinedField4,val=>{job.userDefinedField4=val})"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.exportControlledProduct && elementDict.exportControlledProduct.viewable" slot="exportControlledProduct">
          <line-label slot="label" :class="elementDict.exportControlledProduct.isRequire ? 'blue' : ''" :label="elementDict.exportControlledProduct.label" />
          <el-select
            v-model="job.exportControlledProduct"
            no="exportControlledProduct"
            :disabled="viewStatus || !elementDict.exportControlledProduct.writable"
            :placeholder="''"
            :clearable="true"
            size="mini"
          >
            <el-option
              v-for="(item,index) in EXPORT_CONTROLLED_PRODUCT"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.taxNature && elementDict.taxNature.viewable" slot="taxNature">
          <line-label slot="label" :class="elementDict.taxNature.isRequire ? 'blue' : ''" :label="elementDict.taxNature.label" />
          <el-select
            v-model="job.taxNature"
            no="taxNature"
            :disabled="viewStatus || !elementDict.taxNature.writable"
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in TAX_NATURES"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <el-form-item v-if="elementDict.boardSales && elementDict.boardSales.viewable" slot="boardSales" :label="$t('SeaExport.BoardSales')">
          <line-label slot="label" :class="elementDict.boardSales.isRequire ? 'blue' : ''" :label="elementDict.boardSales.label" />
          <el-input v-model="job.boardSales" :disabled="true" no="BoardSales" :rows="5" />
        </el-form-item>
        <el-form-item v-if="elementDict.boardCsr && elementDict.boardCsr.viewable" slot="boardCsr" :label="$t('SeaExport.BoardCsr')">
          <line-label slot="label" :class="elementDict.boardCsr.isRequire ? 'blue' : ''" :label="elementDict.boardCsr.label" />
          <el-input v-model="job.boardCsr" :disabled="true" no="BoardCsr" :rows="5" />
        </el-form-item>
        <el-form-item v-if="elementDict.boardSite && elementDict.boardSite.viewable" slot="boardSite" :label="$t('SeaExport.BoardSite')">
          <line-label slot="label" :class="elementDict.boardSite.isRequire ? 'blue' : ''" :label="elementDict.boardSite.label" />
          <el-input v-model="job.boardSite" :disabled="true" no="BoardSite" :rows="5" />
        </el-form-item>
        <el-form-item v-if="elementDict.arrivalMethod && elementDict.arrivalMethod.viewable" slot="arrivalMethod" :label="$t('SeaExport.ArrivalMethod')">
          <line-label slot="label" :class="elementDict.arrivalMethod.isRequire ? 'blue' : ''" :label="elementDict.arrivalMethod.label" />
          <el-select v-model="job.arrivalMethod" :disabled="true" :placeholder="$t('Message.PleaseSelect')" size="mini" no="ArrivalMethod">
            <el-option
              v-for="(item,index) in AirExportConstants.ARRIVAL_METHOD"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item v-if="elementDict.flightLabel && elementDict.flightLabel.viewable" slot="flightLabel" :label="$t('SeaExport.FlightLabel')">
          <line-label slot="label" :class="elementDict.flightLabel.isRequire ? 'blue' : ''" :label="elementDict.flightLabel.label" />
          <el-select v-model="job.flightLabel" :disabled="true" :placeholder="$t('Message.PleaseSelect')" size="mini" no="FlightLabel">
            <el-option
              v-for="(item,index) in AirExportConstants.AIR_FLIGHT_LABEL"
              :key="index"
              :label="$store.getters.language==='zh'?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <div v-if="elementDict.goodsInfo && elementDict.goodsInfo.viewable" slot="goodsInfo" class="goods-info" style="width: 1100px">
          <el-form-item class="auto-width">
            <div style="display: flex;">
              <div style="display: flex;text-align: left" class="title-row">
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:188px;text-align: right;">{{ $t('SeaExport.Quantity') }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Weight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.Cubage') }}{{ openImperial ? 'CFT' : 'CBM' }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('SeaExport.ChargedWeight') }}{{ openImperial ? 'LB' : 'KGS' }}</div>
                <div style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;">{{ $t('queryJob.Density') }}kg/m³</div>
              </div>
              <div v-if="showImperialButton && viewStatus" style="font-size: 12px;font-weight: normal;color: #404144;white-space: nowrap;width:200px;text-align: right;padding-left: 50px">
                {{ $t('CargoMsg.Cargo_ImperialUnits') }}
                <div :class="isOpenImperial?'el-switch is-checked':'el-switch'">
                  <span class="el-switch__core" style="width: 40px;" @click="isOpenImperial = !isOpenImperial" />
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoContract && elementDict.goodsInfoContract.viewable" slot="goodsInfoContract" class="goods-info" style="width: 1100px">
          <el-form-item class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoContract.isRequire ? 'blue' : ''" :label="$t('SeaExport.Consignation')" />
            <auto-number-input
              v-model="job.quantityContract"
              no="18"
              :precision="0"
              :min="0"
              :disabled="true"
              style="margin-left: 0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightContractImperial"
              no="weightContractImperial"
              :precision="2"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeContractImperial"
              no="cubAgeContractImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightImperial"
              no="chargeWeightImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightContract"
              no="19"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="weightContractChange"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageContract"
              no="20"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="cubageContractChange"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeight"
              no="21"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-model="job.densityContract"
              :precision="3"
              :min="0"
              :disabled="true"
              no="78"
            />
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoBooking && elementDict.goodsInfoBooking.viewable" slot="goodsInfoBooking" class="goods-info" style="width: 1100px">
          <el-form-item :label="$t('SeaExport.Booking')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoBooking.isRequire ? 'blue' : ''" :label="$t('SeaExport.Booking')" />
            <auto-number-input
              v-model="job.quantityBooking"
              :disabled="viewStatus || !elementDict.goodsInfoBooking.writable"
              no="22"
              :precision="0"
              :min="0"
              style="margin-left: 0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightBookingImperial"
              :disabled="viewStatus || !elementDict.goodsInfoBooking.writable"
              no="weightBookingImperial"
              :precision="2"
              :min="0"
              @change="pm.weightCubAgeImperialChangeHandler('weightBooking')"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeBookingImperial"
              :disabled="viewStatus || !elementDict.goodsInfoBooking.writable"
              no="cubAgeBookingImperial"
              :precision="3"
              :min="0"
              @change="pm.weightCubAgeImperialChangeHandler('cubageBooking')"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightBookingImperial"
              no="chargeWeightBookingImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightBooking"
              :disabled="viewStatus || !elementDict.goodsInfoBooking.writable"
              no="23"
              :precision="3"
              :min="0"
              @change="pm.weightCubageChangeHandler('weightBooking')"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageBooking"
              :disabled="viewStatus || !elementDict.goodsInfoBooking.writable"
              no="24"
              :precision="3"
              :min="0"
              @change="pm.weightCubageChangeHandler('cubageBooking')"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeightBooking"
              no="25"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-model="job.densityBooking"
              :disabled="viewStatus || !elementDict.goodsInfoBooking.writable"
              :precision="3"
              :min="0"
              no="79"
            />
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoActual && elementDict.goodsInfoActual.viewable" slot="goodsInfoActual" class="goods-info" style="width: 1100px">
          <el-form-item :label="$t('SeaExport.FrontCabinActual')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoActual.isRequire ? 'blue' : ''" :label="$t('SeaExport.FrontCabinActual')" />
            <auto-number-input
              v-model="job.quantityActual"
              no="26"
              :precision="0"
              :min="0"
              :disabled="true"
              style="margin-left: 0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightActualImperial"
              no="weightActualImperial"
              :precision="2"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeActualImperial"
              no="cubAgeActualImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cWeightImperial"
              no="cWeightImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightActual"
              no="27"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="weightActualChange"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageActual"
              no="28"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="cubageActualChange"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cWeight"
              no="29"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="pm.weightCubageChangeHandler('chargeWeightActual')"
            />
            <auto-number-input
              v-model="job.densityActual"
              :precision="3"
              :min="0"
              :disabled="true"
              no="80"
            />
          </el-form-item>
        </div>
        <div v-if="elementDict.goodsInfoDocument && elementDict.goodsInfoDocument.viewable" slot="goodsInfoDocument" class="goods-info" style="width: 1100px">
          <el-form-item :label="$t('SeaExport.Documentation')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.goodsInfoDocument.isRequire ? 'blue' : ''" :label="$t('SeaExport.Documentation')" />
            <auto-number-input
              v-model="cargoDoc.quantity"
              :disabled="viewStatus || !elementDict.goodsInfoDocument.writable"
              no="30"
              :precision="0"
              :min="0"
              style="margin-left: 0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="cargoDoc.weightImperial"
              :disabled="viewStatus || !elementDict.goodsInfoDocument.writable"
              no="weightImperial"
              :precision="2"
              :min="0"
              @change="pm.weightCubAgeImperialChangeHandler('weight')"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="cargoDoc.cubAgeImperial"
              :disabled="viewStatus || !elementDict.goodsInfoDocument.writable"
              no="cubAgeImperial"
              :precision="3"
              :min="0"
              @change="pm.weightCubAgeImperialChangeHandler('cubage')"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="cargoDoc.chargeWeightImperial"
              no="chargeWeightImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="cargoDoc.weight"
              :disabled="viewStatus || !elementDict.goodsInfoDocument.writable"
              no="31"
              :precision="3"
              :min="0"
              @change="pm.weightCubageChangeHandler('weight')"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="cargoDoc.cubage"
              :disabled="viewStatus || !elementDict.goodsInfoDocument.writable"
              no="32"
              :precision="3"
              :min="0"
              @change="pm.weightCubageChangeHandler('cubage')"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="cargoDoc.cWeight"
              no="33"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="pm.weightCubageChangeHandler('cWeight')"
            />
            <auto-number-input
              v-model="job.densityDoc"
              :disabled="viewStatus || !elementDict.goodsInfoDocument.writable"
              :precision="3"
              :min="0"
              no="81"
            />
          </el-form-item>
        </div>
        <div v-if="elementDict.quantityStation && elementDict.quantityStation.viewable" slot="quantityStation" class="goods-info" style="width: 1100px">
          <el-form-item :label="$t('SeaExport.FreightStation')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.quantityStation.isRequire ? 'blue' : ''" :label="$t('SeaExport.FreightStation')" />
            <auto-number-input
              v-model="job.quantityStation"
              no="150"
              :precision="0"
              :min="0"
              :disabled="true"
              style="margin-left: 0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightStationImperial"
              no="weightStationImperial"
              :precision="2"
              :disabled="true"
              :min="0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeStationImperial"
              no="cubAgeStationImperial"
              :precision="3"
              :disabled="true"
              :min="0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightStationImperial"
              no="chargeWeightStationImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightStation"
              no="151"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="weightStationChange(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageStation"
              no="152"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="cubageStationChange(true)"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeightStation"
              no="153"
              :precision="3"
              :disabled="true"
              :min="0"
            />
            <auto-number-input
              v-model="job.densityStation"
              :precision="3"
              :min="0"
              :disabled="true"
              no="154"
            />
          </el-form-item>
        </div>
        <div v-if="elementDict.quantitySigning && elementDict.quantitySigning.viewable" slot="goodsInfo" class="goods-info" style="width: 1100px">
          <el-form-item :label="$t('SeaExport.SignBill')" class="goods-info-item">
            <line-label slot="label" :class="elementDict.quantitySigning.isRequire ? 'blue' : ''" :label="$t('SeaExport.SignBill')" />
            <auto-number-input
              v-model="job.quantitySigning"
              no="156"
              :precision="0"
              :min="0"
              :disabled="true"
              style="margin-left: 0"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.weightSigningImperial"
              no="weightSigningImperial"
              :precision="2"
              :min="0"
              :disabled="true"
              @change="weightSigningChange"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.cubAgeSigningImperial"
              no="cubAgeSigningImperial"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="cubageSigningChange"
            />
            <auto-number-input
              v-show="openImperial"
              v-model="job.chargeWeightSigningImperial"
              no="chargeWeightSigningImperial"
              :precision="3"
              :min="0"
              :disabled="true"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.weightSigning"
              no="157"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="weightSigningChange"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.cubageSigning"
              no="158"
              :precision="3"
              :min="0"
              :disabled="true"
              @change="cubageSigningChange"
            />
            <auto-number-input
              v-show="!openImperial"
              v-model="job.chargeWeightSigning"
              no="159"
              :precision="3"
              :disabled="true"
              :min="0"
            />
            <auto-number-input
              v-model="job.densitySigning"
              :precision="3"
              :min="0"
              :disabled="true"
              no="160"
            />
          </el-form-item>
        </div>
        <el-form-item
          v-if="elementDict.packing && elementDict.packing.viewable"
          slot="packing"
          style="width: fit-content;"
        >
          <line-label slot="label" :class="elementDict.packing.isRequire ? 'blue' : ''" :label="elementDict.packing.label" />
          <cargo-packing-select
            no="46"
            style="width: 186px"
            :default-value="job.packing"
            :disabled="viewStatus || !elementDict.packing.writable"
            :callback-params="{}"
            placeholder=" "
            @change="p => {p.key = 'packing';setJobSelectValue(p)}"
          />
        </el-form-item>
        <el-form-item v-if="elementDict.slac && elementDict.slac.viewable" slot="slac" label-width="100px" style="margin-left: 10px;width: fit-content;">
          <line-label slot="label" :class="elementDict.slac.isRequire ? 'blue' : ''" :label="elementDict.slac.label" />
          <el-input-number v-model="job.slac" no="slac" style="width: 88px;" :min="0" :precision="0" :controls="false" :disabled="viewStatus || !elementDict.slac.writable" @change="p=>{pm.slacChangeHandler(p)}" />
        </el-form-item>
        <el-form-item v-if="elementDict.cargoEnglishName && elementDict.cargoEnglishName.viewable" slot="cargoEnglishName" class="auto-width" style="width: 290px">
          <line-label slot="label" :class="elementDict.cargoEnglishName.isRequire ? 'blue' : ''" :label="elementDict.cargoEnglishName.label" />
          <div style="position:relative">
            <cargo-textarea
              v-model="job.cargoEnglishName"
              no="17"
              type="textarea"
              :rows="5"
              :disabled="viewStatus || !elementDict.cargoEnglishName.writable"
              :auto-uppercase="isUppercaseByConfig"
              @dblclick.native="showAdvanceTextDialog(elementDict.cargoEnglishName.lab,job.cargoEnglishName,val=>{pm.cargoEnglishNameChangeHandler(val)},true,null,isUppercaseByConfig , {
                maxChar: 0
              })"
            />
            <char-count :value="job.cargoEnglishName" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.mark && elementDict.mark.viewable" slot="mark" class="auto-width" style="width: 290px">
          <line-label slot="label" :class="elementDict.mark.isRequire ? 'blue' : ''" :label="elementDict.mark.label" />
          <div style="position:relative">
            <cargo-textarea
              v-model="job.mark"
              no="41"
              type="textarea"
              :rows="5"
              :disabled="viewStatus || !elementDict.mark.writable"
              :auto-uppercase="isUppercaseByConfig"
              @dblclick.native="showAdvanceTextDialog(elementDict.mark.label,job.mark,val=>{pm.markChangeHandler(val)},true,null,isUppercaseByConfig , {
                maxChar: 0
              })"
            />
            <char-count :value="job.mark" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.cargoChineseName && elementDict.cargoChineseName.viewable" slot="cargoChineseName" class="auto-width" style="width: 290px">
          <line-label slot="label" :class="elementDict.cargoChineseName.isRequire ? 'blue' : ''" :label="elementDict.cargoChineseName.label" />
          <div style="position:relative">
            <cargo-textarea
              v-model="job.cargoChineseName"
              no="49"
              type="textarea"
              :rows="5"
              :disabled="viewStatus || !elementDict.cargoChineseName.writable"
              @dblclick.native="showAdvanceTextDialog(elementDict.cargoChineseName.label,job.cargoChineseName,val=>{job.cargoChineseName=val},true,null,true , {
                maxChar: 0
              })"
            />
            <char-count :value="job.cargoChineseName" />
          </div>
        </el-form-item>
        <el-form-item v-if="elementDict.rateType && elementDict.rateType.viewable" slot="rateType">
          <line-label slot="label" :class="elementDict.rateType.isRequire ? 'blue' : ''" :label="elementDict.rateType.label" />
          <el-select
            v-model="job.rateType"
            :disabled="viewStatus || !elementDict.rateType.writable"
            no="rateType"
            clearable
            :placeholder="$t('SeaExport.PleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="(item,index) in rateType"
              :key="index"
              :label="isZh?item.chineseName:item.englishName"
              :value="item.code"
            />
          </el-select>&nbsp;
        </el-form-item>
        <div slot="ticketsInfo" class="section">
          <div class="form-row">
            <span class="title">{{ $t('SeaExport.TicketsInfo') }}</span>
            <div style="display:flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px">
              <span>{{ $t('SeaExport.TotalTickets') }}:</span><span style="margin-right: 5px;">{{ job.lclSlaves ? job.lclSlaves.length : 0 }}</span>
              <div v-if="viewStatus && viewSource === 'AeBooking'" v-show="cooperateEdit" class="triggers">
                <el-button no="66" type="primary" @click="newSubJobHandler">{{ $t('SeaExport.NewTickets') }}</el-button>
                <el-button no="67" type="primary" :disabled="!selectedRow" @click="editSubJobHandler">{{ $t('SeaExport.EditTickets') }}</el-button>
                <el-button no="68" type="primary" :disabled="Number(job.operateType) !== 0" @click="attachSubJobHandler">{{ $t('SeaExport.AddTickets') }}</el-button>
                <el-button no="69" type="danger" :disabled="!selectedRow || viewSource === 'financeDetail'" @click="detachSubJobHandler">{{ $t('SeaExport.RemoveTickets') }}</el-button>
              </div>
            </div>
            <div style="min-height: 200px;flex-direction: column">
              <cargo-ag-grid
                config-module="150006"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                style="height:350px"
                @gridReady="params=>{gridApi=params.api}"
              />
            </div>
          </div>
        </div>
      </tab-master-UICustom-layout>
    </el-form>
    <!--输入中转信息-->
    <transit-port-dialog :visible.sync="transitPortDialog.visible" :job="job" @enter="transitPortEnterHandler" />
    <!--选择主单-->
    <select-mawb-dialog :visible.sync="selectMawbDialog.visible" :carrier-id="selectMawbDialog.carrierId" :type="selectMawbDialog.type" :operate-type="selectMawbDialog.operateType" @enterEvent="selectedMAWBHandler" />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="70"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="closeAdvanceText"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="viewStatus"
        :text-chars="advanceTextDialog.formatObj.maxChar"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="advanceTextDialog.formatObj.warningCount"
        style="height: 320px;"
        no="85"
      />
      <span slot="footer">
        <el-button v-show="!viewStatus" no="71" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="71_1"
          @click="advanceTextDialog.visible=false;closeAdvanceText()"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 票数填写弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="72"
      :visible.sync="ticketDialog.visible"
      :title="$t('SeaExport.FillInQuantityOfVotes')"
      width="270px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form label-width="50px" label-position="right">
        <el-form-item :label="$t('SeaExport.Number')+'：'">
          <el-input-number v-model="ticketDialog.value" no="73" :precision="0" :min="1" :max="50" :controls="false" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button no="74" type="primary" @click="toAddTicket">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="75" type="primary" @click="ticketDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
    <!--加入小票弹窗-->
    <query-ae-lcl-dialog
      :visible.sync="queryAeLclDialog.visible"
      :job="job"
      @attachSubJobCallBackHandler="attachSubJobCallBackHandler"
    />
  </div>
</template>

<script>
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea'
import { TabError } from '@/utils/class/TabError'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import tabMasterUICustomLayout from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMasterUICustomLayout'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import tabMaster from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster'
import StrUtils from '@/utils/StrUtils'
import * as BookingTerm from '@/class/cargo/model/parameters/BookingTerm'
import cargoInput from '@/components/Cargo/Common/cargoInput.vue'
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import { handleBlur } from '@/utils/commonUtil'
import { AutoComplete } from '@/utils/class/AdvanceSelect'
import microApp from '@micro-zoe/micro-app'
import { toNumArray, toTxt } from '@/utils/commonUtil'

export default {
  name: 'TabMasterUICustom',
  components: { cargoTextarea, tabMasterUICustomLayout, cargoInput },
  extends: tabMaster,
  props: {
    previewConfig: { type: Object, default: null },
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      handleBlur, AutoComplete,
      elementBlocks: [],
      elementDict: {},
      fieldDict: {},
      superFunction: null, // 用于调用父级的方法
      editMawblNoMode: 0,
      AirExportConstants,
      userDefinedRoleDataUI: { // 子应用自定义岗位
        filedLable: 'CargoMsg.Cargo_userDefinedRole3',
        labelWidth: '133px',
        labelPosition: 'right',
        no: 'userDefinedRoleId3',
        fieldData: this.job ? this.job.userDefinedRoleId3 : null,
        disabled: this.readonly,
        mainClass: 'details-view main-content tabs-container',
        itemClass: '',
        officeId: null,
        category: 'role',
        shape: 'userDefinedRole3',
        staticOptions: null,
        mergeLoad: true
      }
    }
  },
  computed: {
    /**
     * CARGO-46018 友邦：空运订舱中主单号只能通过主单管理维护的单号进行选择
     * 0–自由编辑，可手动输入也可选择主单号列表
     * 1–友邦模式，当订舱性质=自订舱时，输入框置灰，只能通过选择列表主单号。否则可自由编辑，可手动也可列表选择
     */
    isEditablemawbNoInput() {
      return !(this.mblEnable && (this.editMawblNoMode === 0 || !(this.editMawblNoMode === 1 && this.job.bookingTerm === BookingTerm.SB_BOOKING_TYPE.code)))
    },
    showGoodsInfo() {
      return (this.elementDict.goodsInfoContract && this.elementDict.goodsInfoContract.viewable) ||
        (this.elementDict.goodsInfoBooking && this.elementDict.goodsInfoBooking.viewable) ||
        (this.elementDict.goodsInfoActual && this.elementDict.goodsInfoActual.viewable) ||
        (this.elementDict.goodsInfoDocument && this.elementDict.goodsInfoDocument.viewable && this.job.operateType !== 0) ||
        (this.elementDict.quantityStation && this.elementDict.quantityStation.viewable) ||
        (this.elementDict.quantitySigning && this.elementDict.quantitySigning.viewable)
    }
  },
  watch: {
    '$store.getters.currentOfficeId': {
      handler() {
        this.loadPageConfig()
      }
    },
    'job.exportControlledProduct': {
      immediate: true,
      handler(val) {
        if (val === 0) {
          this.job.exportControlledProduct = ''
        }
      }
    }
  },
  created() {
    this.loadPageConfig()
    this.editMawblNoMode = Number(this.context.config.get('EditMawblNoMode'))
  },
  methods: {
    toTxt,
    toNumArray,
    async onShow(row, isRefresh) {
      this.superFunction = this.$options.extends.methods.onShow
      await this.superFunction(row, isRefresh)
      if (isRefresh) {
        const pageType = this.$route.name === 'AeBookingVerify' ? UICustomConstants.AIR_VERIFY_BOOKING_BASIC : UICustomConstants.AIR_BOOKING_BASIC
        UICustomUtil.handleViewAndWrite(pageType, this.elementDict, row, true)
      }
    },
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
      if (obj.key === 'designationAgent' && StrUtils.isEmpty(this.job.uuid)) {
        this.checkCredit()
      }
    },
    oncustomJobTypeChange(obj) {
      this.setJobSelectValue(obj)
      this.job.secondaryCustomJobType = ''
      this.setSecondaryCustomJobTypeFunc()
    },
    loadPageConfig() {
      const pageType = this.$route.name === 'AeBookingVerify' ? UICustomConstants.AIR_VERIFY_BOOKING_BASIC : UICustomConstants.AIR_BOOKING_BASIC
      const pageConfig = UICustomUtil.getPageConfig(pageType, this.$store.getters.currentOfficeId, true)
      this.elementBlocks = pageConfig.elementBlocks
      this.elementDict = pageConfig.elementDict
      this.fieldDict = pageConfig.fieldDict
    },
    async validateForm() {
      const form = this.job
      for (const key in this.elementDict) {
        const element = this.elementDict[key]
        if (!element.viewable || !element.writable || !element.isRequire) {
          continue
        }
        if (!element.fieldNames) {
          continue
        }
        for (const fieldName of element.fieldNames) {
          const field = this.fieldDict[fieldName]
          if (fieldName === 'exChangeAgent') {
            if (!this.job.dischargingPortDoor) {
              continue
            }
          }
          if (fieldName === 'secondaryCustomJobType') {
            if (!(this.job.customJobType && this.secondaryCustomJobTypeList.length > 0)) {
              continue
            }
          }
          if (fieldName === 'measurements') {
            continue
          }
          if (fieldName === 'userDefinedRoleId1' || fieldName === 'userDefinedRoleId2') {
            if (!this.isAddUserDefinedRoles) {
              continue
            }
          }
          if (fieldName === 'quantityStation' || fieldName === 'quantitySigning') {
            continue
          }
          if (fieldName === 'designationAgent') {
            if (form.cargoSource === CargoSource.NC_CARGO_SOURCE.code && !form.designationAgent) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'masterBasicTab')
            }
          } else if (fieldName === 'cargoCode') {
            if (StrUtils.isEmpty(form.cargoCode) || StrUtils.isEmpty(form.cargoName)) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'masterBasicTab')
            }
          } else if (fieldName === 'taxNature') {
            if (form[fieldName] === '' || form[fieldName] === null) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'masterBasicTab')
            }
          } else {
            if (typeof form[fieldName] !== 'boolean' && StrUtils.isEmpty(form[fieldName])) {
              throw new TabError(this.$t('Message.FieldValueCannotBeNull', [field.label]), 'masterBasicTab')
            }
          }
        }
      }
      if (this.elementDict.goodsInfoBooking && this.elementDict.goodsInfoBooking.viewable && this.elementDict.goodsInfoBooking.writable && this.elementDict.goodsInfoBooking.isRequire) {
        if (!form.quantityBooking || !form.weightBooking || !form.cubageBooking || !form.chargeWeightBooking || !form.densityBooking) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.goodsInfoBooking.label]), 'masterBasicTab')
        }
      }
      if (this.elementDict.goodsInfoDocument && this.elementDict.goodsInfoDocument.viewable && this.elementDict.goodsInfoDocument.writable && this.elementDict.goodsInfoDocument.isRequire) {
        if (form.operateType !== 0 && (!this.cargoDoc.quantity || !this.cargoDoc.weight || !this.cargoDoc.cubage || !this.cargoDoc.cWeight || !form.densityDoc)) {
          throw new TabError(this.$t('Message.FieldValueCannotBeNull', [this.elementDict.goodsInfoDocument.label]), 'masterBasicTab')
        }
      }
      this.superFunction = this.$options.extends.methods.validateForm
      return await this.superFunction()
    },
    setUserDefinedRoleDataUI() {
      return
      // userDefinedRoleId3
      const userDefinedRoleData3 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData3.fieldData = this.job.userDefinedRoleId3 || ''
      userDefinedRoleData3.disabled = this.readonly
      userDefinedRoleData3.filedLable = 'CargoMsg.Cargo_userDefinedRole3'
      userDefinedRoleData3.no = 'userDefinedRoleId3'
      userDefinedRoleData3.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData3.category = 'role'
      userDefinedRoleData3.shape = 'userDefinedRole3'
      userDefinedRoleData3.staticOptions = this.userPortRoleData.userDefinedRole3
      userDefinedRoleData3.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData3)
      microApp.forceSetData('child-user-defined-role-ae-master-userDefinedRoleId3', userDefinedRoleData3)
      // userDefinedRoleId4
      const userDefinedRoleData4 = { ...this.userDefinedRoleDataUI }
      userDefinedRoleData4.fieldData = this.job.userDefinedRoleId4 || ''
      userDefinedRoleData4.disabled = this.readonly
      userDefinedRoleData4.filedLable = 'CargoMsg.Cargo_userDefinedRole4'
      userDefinedRoleData4.no = 'userDefinedRoleId4'
      userDefinedRoleData4.officeId = this.$store.getters.currentOfficeId
      userDefinedRoleData4.category = 'role'
      userDefinedRoleData4.shape = 'userDefinedRole4'
      userDefinedRoleData4.staticOptions = this.userPortRoleData.userDefinedRole4
      userDefinedRoleData4.mergeLoad = true
      console.log('主应用发送UserDefinedRole:', userDefinedRoleData4)
      microApp.forceSetData('child-user-defined-role-ae-master-userDefinedRoleId4', userDefinedRoleData4)
    },
    userDefinedRoleDataChangeUI(e) {
      console.log('主应用获取UserDefinedRole:', e.detail.data)
      if (e.detail.data) {
        if (e.detail.data.type === 'created') {
          this.setUserDefinedRoleDataUI()
        } else {
          if (e.detail.data.no === 'userDefinedRoleId3') {
            this.job.userDefinedRoleId3 = e.detail.data.fieldData
            this.pm.userDefinedRoleId3Handler(this.job.userDefinedRoleId3)
          } else if (e.detail.data.no === 'userDefinedRoleId4') {
            this.job.userDefinedRoleId4 = e.detail.data.fieldData
            this.pm.userDefinedRoleId4Handler(this.job.userDefinedRoleId4)
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
#app .tab-master-ui-custom {
  .fit-content {
    .form-column {
      width: auto;
    }
  }
}
.goods-info{
  /deep/ .goods-info-item{
    .el-form-item__content{
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      .el-input{
        width: 190px;
        margin-left: 12px;
        text-align: right !important;
      }
    }
  }
}
/deep/ .checkbox-content {
  display: flex;
  .el-checkbox__label {
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
